import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DemoApp.html?raw';
import DateInput from '../../moreCore/UI/DateInput/DateInput';
import '../../moreCore/UI/DateInput/DateInput';
import DateTimeInput from '../../moreCore/UI/DateTimeInput/DateTimeInput';
import '../../moreCore/UI/DateTimeInput/DateTimeInput';
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import '../../moreCore/UI/SelectBox/SelectBox';
import HintBox from '../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../moreCore/UI/EntityBased/HintBox/HintBox';
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';
import '../../moreCore/UI/RadioGroup/RadioGroup';
import DatePicker from '../../moreCore/UI/DatePicker/DatePicker';
import '../../moreCore/UI/DatePicker/DatePicker';
import Edit from '../../moreCore/UI/Edit/Edit';
import '../../moreCore/UI/Edit/Edit';
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';
import '../../moreCore/UI/NumberInput/NumberInput';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import '../../moreCore/UI/CheckBox/CheckBox';
import Button from '../../moreCore/UI/Button/Button';
import '../../moreCore/UI/Button/Button';
import FileUpload from '../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import '../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import PhoneInput from '../../moreCore/UI/PhoneInput/PhoneInput';
import '../../moreCore/UI/PhoneInput/PhoneInput';
import TimeZoneSelector from '../../moreCore/UI/TimeZoneSelector/TimeZoneSelector';
import '../../moreCore/UI/TimeZoneSelector/TimeZoneSelector';
import DateTimeTZoneSelector from '../../moreCore/UI/DateTimeTZoneSelector/DateTimeTZoneSelector';
import "../../moreCore/UI/DateTimeTZoneSelector/DateTimeTZoneSelector";
import gReCaptcha from '../../moreCore/UI/gReCaptcha/gReCaptcha';
import "../../moreCore/UI/gReCaptcha/gReCaptcha";
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import "../../moreCore/UI/StaticTable/StaticTable";
import MultiselectBox from '../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import "../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox";
import moreCoreCalendar from '../../moreCore/UI/moreCoreCalendar/moreCoreCalendar/moreCoreCalendar';
import "../../moreCore/UI/moreCoreCalendar/moreCoreCalendar/moreCoreCalendar";
import PassowrdChange from '../../moreCore/UI/PasswordChange/PasswordChangeHome';
import "../../moreCore/UI/PasswordChange/PasswordChangeHome";
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import "../../moreCore/UI/SearchSelect/SearchSelect";
import NestedTable from '../../moreCore/UI/NestedTable/NestedTable';
import "../../moreCore/UI/NestedTable/NestedTable";
import EvBookingEditor from '../EvBookingEditor/EvBookingEditor';
import "../EvBookingEditor/EvBookingEditor"



const enum EditInputType {
    text = "text",
    password = "password",
    number = "number"
    //date = "date",
    //time = "time"
}
class DemoApp extends compose(_WidgetBaseSP) {
    templateString: any = template;

    selectboxContainer: HTMLDivElement;
    radioGroup_node: HTMLElement;
    myDateInput: MdsLax<InstanceType<typeof DateInput>>;
    myDateTimeInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    myRadioGroup: MdsLax<InstanceType<typeof RadioGroup>>;
    RadioGroup_markup: MdsLax<InstanceType<typeof RadioGroup>>;
    hintbox_Demo01: MdsLax<InstanceType<typeof HintBox>>;
    SelectBox_markup: MdsLax<InstanceType<typeof SelectBox>>;
    selectBox: MdsLax<InstanceType<typeof SelectBox>>;
    datePicker_Single: MdsLax<InstanceType<typeof DatePicker>>;
    datePicker_Multi: MdsLax<InstanceType<typeof DatePicker>>;
    edit_demo_node: MdsLax<InstanceType<typeof Edit>>;
    NumberInput: MdsLax<InstanceType<typeof NumberInput>>;
    CheckBoxInput: MdsLax<InstanceType<typeof CheckBox>>;
    button_demo: MdsLax<InstanceType<typeof Button>>;
    fileUpload: MdsLax<InstanceType<typeof FileUpload>>;
    phoneInput: PhoneInput;
    TimeZoneSelector: MdsLax<InstanceType<typeof TimeZoneSelector>>;
    TimeZone_DateTimeInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    DateTimeTZoneSelector: MdsLax<InstanceType<typeof DateTimeTZoneSelector>>;
    gReCaptcha: MdsLax<InstanceType<typeof gReCaptcha>>;
    staticTable: MdsLax<InstanceType<typeof StaticTable>>;
    //SelectEntityDialog: SelectEntityDialog;
    MultiselectBox: MdsLax<InstanceType<typeof MultiselectBox>>;
    Calendar: MdsLax<InstanceType<typeof moreCoreCalendar>>;
    PasswordChange: MdsLax<InstanceType<typeof PassowrdChange>>;
    SearchSelect: MdsLax<InstanceType<typeof SearchSelect>>;
    NestedTable: MdsLax<InstanceType<typeof NestedTable>>;
    evBookingEditor: MdsLax<InstanceType<typeof EvBookingEditor>>;
    //RdioGroup Nodes
    radioGroup_DemoInput_value: HTMLInputElement;
    radioGroup_DemoInput_label: HTMLInputElement;
    radioGroup_demo_message: HTMLElement;

    // container nodes for the demoTabs node reference
    myDateinput_containerNode: HTMLElement;
    myDateTimeInput_containerNode: HTMLElement;
    Selectbox_containerNode: HTMLElement;
    RadioGroup_containerNode: HTMLElement;
    HintBox_containerNode: HTMLElement;
    DatePicker_containerNode: HTMLElement;
    Edit_containerNode: HTMLElement;
    edit_demo_valueInput: HTMLInputElement;
    Edit_Display: HTMLElement;
    NumberInput_containerNode: HTMLElement;
    Number_Display: HTMLElement;
    CheckBox_containerNode: HTMLElement;
    CheckBox_demoDataInput: HTMLInputElement;
    Button_containerNode: HTMLElement;
    FileUloadInput_containerNode: HTMLElement;
    programmaticNumberInputContainer: HTMLElement;
    TelInput_containerNode: HTMLElement;
    TimeZoneSelector_containerNode: HTMLElement;
    TimeZoneSelector_display: HTMLElement;
    gReCaptcha_containerNode: HTMLElement;
    recaptcha_container: HTMLElement;
    grecaptcha_display: HTMLElement;
    staticTable_containerNode: HTMLElement;
    SelectEntityDialog_containerNode: HTMLElement;
    testNode: HTMLElement;
    MultiselectBox_containerNode: HTMLElement;
    Calendar_containerNode: HTMLElement;
    PasswordChange_containerNode: HTMLElement;
    SearchSelect_containerNode: HTMLElement;
    NestedTable_containerNode: HTMLElement;

    edit_demo_columnBodyText: HTMLInputElement;
    edit_demo_columnHeadText: HTMLInputElement;


    //Documentation variable
    documentationFile: string;

    // Dom Select localization
    _containerNodeDatasetName: string = "containernode";

    //Demo Tabs
    _onClick_displayDemoTab(e: Event): void {
        let target = e.target as HTMLElement;

        let node = this[target.dataset[this._containerNodeDatasetName]];
        this.displayTab(node, "demo");
    }

    _onClick_displayMarkupTab(e: Event) {
        let target = e.target as HTMLElement;

        let node = this[target.dataset[this._containerNodeDatasetName]];
        this.displayTab(node, "markup");

    }
    _onClick_EventImDemoApp(e: Event): void {
        console.log("aufruf kommt aus docu content");
    }

    _onClick_displayDokuTab(e: Event): void {
        let target = e.target as HTMLElement;

        let containerNode = this[target.dataset[this._containerNodeDatasetName]];

        let demoWidget: any = this[containerNode.dataset["mainwidget"]];

        if (demoWidget && demoWidget.getDocumentationContent) {
            let text = demoWidget.getDocumentationContent();

            this.loadDocumentation(containerNode, text);

            this.displayTab(containerNode, "doku");

        } else {
            alert("There is no Documentation setup for this demo widget");
        }
    }


    loadDocumentation(node: HTMLElement, text: string): void {
        let i;

        let elements = node.getElementsByClassName("tabs");

        for (i = 0; i < elements.length; i++) {
            if (this.UiModder.domClass.contains(elements[i], "doku")) {
                this.UiModder.domAttr.set(elements[i], "innerHTML", text);
            }
        }
    }

    displayTab(node: HTMLElement, tabName: string): void {
        let i;
        let elements = node.getElementsByClassName("tabs");

        for (i = 0; i < elements.length; i++) {
            this.UiModder.domClass.contains(elements[i], tabName) ?
                this.UiModder.domAttr.set(elements[i], "style", "display:block") :
                this.UiModder.domAttr.set(elements[i], "style", "display:none");

        }
    }

    // DateInput Methods----------------------START
    //

    _onClick_Date_GetValue(): void {
        console.log("DateInput: Date: ", this.myDateInput.getValue());

        // this.UiModder.domStyle.set(this.domNode, "background", "red");
        //let myDateInput = new DateInput();
        //myDateInput.setLabel("Start");
        //myDateInput.placeAt(this.domNode);
    }

    _onClick_Date_GetValueAsString(): void {
        console.log("DateInput String: ", this.myDateInput.toStringISO(this.myDateInput.getValue()))
    }


    _onClick_Date_setValue(): void {
        this.myDateInput.setValue(new Date());
    }


    // DateInput Methods----------------------END
    //
    // DateTimeInput Methods----------------------START
    //

    _onClick_DateTime_GetValue(): void {
        console.log("_onClick_Date_GetValue: ", this.myDateTimeInput.getValue());
        console.log("UTC Offset ", this.myDateTimeInput.getUtcOffsetMinutes())

        // this.UiModder.domStyle.set(this.domNode, "background", "red");
        //let myDateInput = new DateInput();
        //myDateInput.setLabel("Start");
        //myDateInput.placeAt(this.domNode);
    }

    _onClick_DateTime_GetValue_ISO(): void {
        let date: Date = this.myDateTimeInput.getValue().date;
        console.log("_onClick_DateTime_GetValue_ISO: ", this.myDateTimeInput.toStringISO(date));
    }

    _onClick_DateTime_GetValue_InputStrings(): void {
        let iso = this.myDateTimeInput.toStringISO(this.myDateTimeInput.getValue().date);
        let inputValues = this.myDateTimeInput.ISOStringToInputValues(iso); // gibt Object {date:date, time:time} zurück
        console.log(`_onClick_DateTime_GetValue_InputStrings: ${inputValues["date"]} is the day, ${inputValues["time"]} is the time`);
    }

    _onClick_DateTime_SetValue(): void {
        this.myDateTimeInput.setValue(new Date());
    }

    _onClick_DateTime_ToggleValidate(): void {
        this.myDateTimeInput.setValidationEnabled(!this.myDateTimeInput.validationEnabled);
        this.myDateTimeInput.setMandatory(!this.myDateTimeInput.getMandatory());
    }

    _onClick_DateTime_Validate(): void {
        this.myDateTimeInput.validateInput();
    }


    // DateTimeInput Methods----------------------END
    //
    // SelectBox Methods----------------------START
    //

    _onClick_SelectBox_Build(): void {

        var select = new SelectBox();

        select.on("valueChange", function (value) { console.log("select changed", value); });

        select.addEntry("a", "erste Option A", true);
        select.addEntry("b", "zweite Option B", true);
        select.addEntry("c", "nicht auswählbar", false);
        select.addEntry("d", "D");
        select.addEntry("e", "E");
        select.addEntry("f", "F");
        select.addEntry("g", "G");

        select.setLabel("Select Label steht hier");

        //select.setBlankOption("0", "bitte wählen - please choose wisely!");
        //select.setPlaceholder("bitte wählen - please choose");
        select.setBlankOption("XXX", "bitte nicht wählen!");

        this.selectBox = select;

        //select.setValue("b", true);

        select.startup();

        this.UiModder.domConstruct.place(select.domNode, this.selectboxContainer);
    }

    _onClick_SelectBox_Multiple(): void {
        this.selectBox.setBlankOption("XXX", "mindestens 2 - max 5");
        this.selectBox.setMultiselectHeight(8);
        this.selectBox.minCount = 2;
        this.selectBox.maxCount = 5;
        this.selectBox.setMultiselect(this.selectBox.isMultiSelect != true);
    }

    _onClick_SelectBox_ToggleValidation(): void {
        this.selectBox.setMandatory(!this.selectBox.isMandatory);
        this.selectBox.setValidationEnabled(this.selectBox.validationEnabled !== true);
    }

    _onClick_SelectBox_Validate(): void {
        this.selectBox.validateInput();
    }

    _onClick_SelectBox_GetLabel(): void {
        alert(this.selectBox.getMultipleValues(true));
    }

    _onClick_SelectBox_GetValue(): void {
        alert(this.selectBox.getValue());
    }

    _onClick_SelectBox_SetC(): void {
        this.selectBox.setValue("c", false, true);
    }

    _onClick_SelectBox_SetCD(): void {
        this.selectBox.setValue("c;d", false, true, ";");
    }

    _onClick_SelectBox_SetBsilent(): void {
        this.selectBox.setValue("b", true);
    }
    // SelectBox Methods----------------------END
    //

    // HintBox Methods----------------------Start
    //

    _onClick_HintBox_GetValue(): void {
        //let entity:Build = this.hintbox_Demo01.getValue() as Building;

        console.log(this.hintbox_Demo01.getValue());
    }

    _onClick_HintBox_ToggleValidation(): void {
        this.hintbox_Demo01.setMandatory(!this.hintbox_Demo01.isMandatory);
        this.hintbox_Demo01.setValidationEnabled(!this.hintbox_Demo01.validationEnabled);
    }

    _onClick_HintBox_Validate(): void {
        this.hintbox_Demo01.validateInput();
    }

    // HintBox Methods----------------------END
    //

    // RadioGroup Methods----------------------START
    //

    _onClick_RadioGroup_Create(): void {

        //dummy data passed as a param normally
        let entries = [
            { value: "value1", label: "label1" },
            { value: "value2", label: "label2" },
            { value: "value3", label: "label3" },
            { value: "value4", label: "label4" },
        ];
        if (this.myRadioGroup == null) {
            let radioGroup = new RadioGroup({ entries }
            );

            radioGroup.placeAt(this.radioGroup_node);

            this.myRadioGroup = radioGroup;
        }
    }

    _onClick_RadioGroup_ToggleValidation(): void {
        this.myRadioGroup.setMandatory(!this.myRadioGroup.isMandatory);
        this.myRadioGroup.setValidationEnabled(!this.myRadioGroup.validationEnabled);

    }
    _onClick_RadioGroup_Validate(): void {
        this.myRadioGroup.validateInput();
    }

    _onClick_RadioGroup_GetValue(): void {
        console.log(this.myRadioGroup.getValue());
    }


    _onClick_RadioGroup_addEntry(): void {
        let value = this.radioGroup_DemoInput_value.value;
        let label = this.radioGroup_DemoInput_label.value;

        this.myRadioGroup.addEntry(value, label);
    }

    _onClick_RadioGroup_removeEntry(): void {
        let value = this.radioGroup_DemoInput_value.value;
        let label = this.radioGroup_DemoInput_label.value;

        this.myRadioGroup.removeEntry(value, label);
    }

    _onClick_RadioGroup_setDisabled(): void {
        let value = this.radioGroup_DemoInput_value.value;
        let label = this.radioGroup_DemoInput_label.value;

        //this.myRadioGroup.setDisabled(value, label, true);
    }

    _onClick_RadioGroup_setValue(): void {
        let value = this.radioGroup_DemoInput_value.value;
        this.myRadioGroup.setValue(value);
    }



    _onClick_RadioGroup_changeAlignment(): void {
        this.myRadioGroup.setAlignment("horizontal");
    }

    _onClick_RadioGroup_enableAgain(): void {
        let value = this.radioGroup_DemoInput_value.value;
        let label = this.radioGroup_DemoInput_label.value;

        //this.myRadioGroup.setDisabled(value, label, false);
    }

    _onClick_RadioGroup_getValueAsLabel(): void {
        console.log(this.myRadioGroup.getValue("label"));
    }

    _onClick_RadioGroup_setGroupLabel(): void {
        let value = this.radioGroup_DemoInput_value.value;
        let label = this.radioGroup_DemoInput_label.value;

        let newLabel = this.radioGroup_DemoInput_label.value || this.radioGroup_DemoInput_label.value
        this.myRadioGroup.setLabel(newLabel);
    }

    _onClick_RadioGroup_removeGroupLabel(): void {
        this.myRadioGroup.removeLabel();
    }

    _onClick_RadioGroup_setReadOnly(): void {
        this.myRadioGroup.setReadonly(!this.myRadioGroup.isReadonly);
    }
    // RadioGroup Methods----------------------END
    //
    //  DatePicker Methods------------------ BEGIN
    //
    _onClick_DatePicker_Single_getValue(): void {
        let date: Date = this.datePicker_Single.getValue();
        console.log("DatePicker SingleSelect Value", date);

        alert(JSON.stringify(date));
    }

    _onClick_DatePicker_Single_setValueNow(): void {
        let now: Date = new Date();
        this.datePicker_Single.setValue(now);
    }

    _onClick_DatePicker_Multi_getValues(): void {
        var values = this.datePicker_Multi.getValues();
        console.log("DatePicker MultiSelect Values", values);
        alert(JSON.stringify(values));
    }

    _onClick_DatePicker_Single_setValuesNow(): void {
        let now: Date = new Date();

        this.datePicker_Multi.setValues([now, new Date(now.getTime() + (1440 * 60 * 1000)), new Date(now.getTime() + (1440 * 2 * 60 * 1000))]);
    }

    _onClick_DatePicker_Single_removeSelectedDates(): void {
        this.datePicker_Single.removeCurrentSelect();
    }

    _onClick_DatePicker_Multi_removeSelectedDates(): void {
        this.datePicker_Multi.removeCurrentSelect();
    }

    //  DatePicker Methods------------------ END
    //
    // Edit Methods----------------------START
    //
    _onClick_Edit_getValue(): void {
        alert(this.edit_demo_node.getValue());
    }

    _onClick_Edit_getLabel(): void {
        alert(this.edit_demo_node.getLabel());
    }

    _onClick_Edit_setValue(): void {
        let value = this.edit_demo_valueInput.value;
        this.edit_demo_node.setValue(value);
    }

    _onClick_Edit_setLabel(): void {
        let value = this.edit_demo_valueInput.value;
        this.edit_demo_node.setLabel(value);
    }

    _onClick_Edit_hideLabel(): void {
        this.edit_demo_node.setLabelVisibility(false);
    }

    _onClick_Edit_setPlaceholder(): void {
        let value = this.edit_demo_valueInput.value;
        this.edit_demo_node.setPlaceholder(value);
    }

    _onChange_Edit_DisplayValue(): void {
        let text = this.edit_demo_node.getValue();
        this.UiModder.domAttr.set(this.Edit_Display, "innerHTML", text)

    }

    _onClick_Edit_setIsMultiline(): void {
        console.log("_onClick_Edit_setIsMultiline");
        this.edit_demo_node.setIsMultiline(!this.edit_demo_node.isMultiline);
    }

    _onClick_Edit_setIsResizeable(): void {
        console.log("_onClick_Edit_setIsResizeable");
        this.edit_demo_node.setIsResizeable(!this.edit_demo_node.isResizeable);
    }
    // Edit Methods----------------------END
    //

    // Number Methods----------------------START
    //
    _onClick_Number_GetValue(): void {
        let value = this.NumberInput.getValue();
        this.UiModder.domAttr.set(this.Number_Display, "innerHTML", typeof (value) + ": " + value);
    }


    _onClick_Number_getStringValue(): void {
        let value = this.NumberInput.getValue();
        let text: string = this.NumberInput.formatToString(value);
        if (this.NumberInput.getUnit()) {
            text += this.NumberInput.getUnit();
        }

        this.UiModder.domAttr.set(this.Number_Display, "innerHTML", typeof (text) + ": " + text);
    }

    _onClick_Number_currency(): void {
        this.NumberInput.setNumberType("currency");
        this.NumberInput.setUnit("€")
    }

    _onClick_Number_decimal(): void {
        this.NumberInput.setNumberType("decimal");
        this.NumberInput.setUnit("m<sup>2</sup>")
    }

    _onClick_Number_setMandatory(): void {
        this.NumberInput.setMandatory(!this.NumberInput.isMandatory);
        this.NumberInput.validateInput();
    }

    _onClick_Number_createNew(): void {
        let input = new NumberInput();

        this.UiModder.domClass.add(input.domNode, "w3-section");

        this.NumberInput = input;

        input.validationErrorMsgText = "must be > 99";
        input.placeAt(this.programmaticNumberInputContainer);
    }

    // Number Methods----------------------END
    //
    // CheckBox Methods----------------------START
    //
    _onCkick_CheckBox_getValue(): void {
        let value: boolean = this.CheckBoxInput.getValue();

        console.log("CheckBox Value == ",value);
    }
    _onCkick_CheckBox_getChecked(): void {
        let checked: boolean = this.CheckBoxInput.getChecked();
        console.log("CheckBox.checked == ", checked);
    }
    _onCkick_CheckBox_toggleCustomStyles(): void {
    //    //this.CheckBoxInput.setIsCustomStyleEnabled(!this.CheckBoxInput.isCustomStyleEnabled);
    //    console.log("this.CheckBoxInput.isCustomStyleEnabled == ", this.CheckBoxInput.isCustomStyleEnabled);
    }
    _onCkick_CheckBox_setToggleStyle(): void {
        //this.CheckBoxInput.setToggleStyle(!this.CheckBoxInput.toggleStyle);
        //console.log("this.CheckBoxInput.toggleStyle == ", this.CheckBoxInput.toggleStyle);

    }
    _onCkick_CheckBox_setValueTrue(): void {
        this.CheckBoxInput.setValue(true);
    }
    _onCkick_CheckBox_setValueTristate(): void {
        this.CheckBoxInput.setValue(null);
    }
    _onCkick_CheckBox_setValueFalse(): void {
        this.CheckBoxInput.setValue(false);
    }
    _onCkick_CheckBox_setIsTristate(): void {
        //this.CheckBoxInput.setIsTristate(!this.CheckBoxInput.isTristate);
        //console.log("this.CheckBoxInput.isTristate == ", this.CheckBoxInput.isTristate);

    }
    _onCkick_CheckBox_toggleReadonly(): void {
        this.CheckBoxInput.setReadonly(!this.CheckBoxInput.isReadonly);
        console.log("this.CheckBoxInput.isReadonly == ", this.CheckBoxInput.isReadonly);

    }
    _onCkick_CheckBox_setActiveLabelLeft(): void {
        this.CheckBoxInput.setLabelAlignment("left");
    }
    _onCkick_CheckBox_setActiveLabelRight(): void {
        this.CheckBoxInput.setLabelAlignment("right");
    }
    _onCkick_CheckBox_toggleIsMandatory(): void {
        this.CheckBoxInput.setMandatory(!this.CheckBoxInput.isMandatory);
        console.log("this.CheckBoxInput.isMandatory == ", this.CheckBoxInput.isMandatory);

    }
    _onCkick_CheckBox_validateInput(): void {

        console.log("this.CheckBoxInput.validateInput() == ", this.CheckBoxInput.validateInput())
    }
    _onCkick_CheckBox_setLabel(): void {
        this.CheckBoxInput.setLabel(this.CheckBox_demoDataInput.value);
    }

    // CheckBox Methods----------------------END
    //

    // File upload Methods ------------------START

    _onUploadFile(): void {
        console.log("FILE UPLOAD (getValue): ", this.fileUpload.getValue());
    }

    // File upload Methods ------------------END

    // Button Methods----------------------START
    //
    _onClick_Button_SetLeftIcon(): void {
        this.button_demo.setIconLeft("fa fa-spinner fa-spin");
    }

    _onClick_Button_SetRightIcon(): void {
        this.button_demo.setIconRight("fa fa-refresh fa-spin");
    }

    _onClick_Button_hideShow(): void {
        this.button_demo.hide();
    }

    _onClick_Button_enableDisable(): void {
        let value: boolean = !this.button_demo.isReadonly;
        this.button_demo.setReadonly(value);
    }

    _onClick_Button_PressEffect(): void {
        this.button_demo.pressEffect();
    }


    // Button Methods----------------------END
    //
    // International Tel Input Methods----------------------START
    //

    _onClick_telInput_getValue(): void {
        console.log(this.phoneInput.getValue());
    }

    // International Tel Input Methods----------------------END
    //
    //// TimeZoneSelector Methods-------------------------START
    //

    _onClick_TimeZoneSelector_getValue(): void {
        console.log(this.TimeZoneSelector.getValue());
    }

    _onValueChangeTzDateTime(): void {

        let inputDate = this.TimeZone_DateTimeInput.getValue();
        this.TimeZoneSelector.setInputDate(inputDate.date);

        //if (inputDate) {
        //    this.TimeZoneSelector_display.innerHTML =
        //        "UTC Time: " + this.TimeZoneSelector.getUtcDate() + "<br>" +
        //        "selectedLocalDate_Date: " + this.TimeZoneSelector.getSelectedLocaleDate_Date() + "<br>" +
        //        "UTC Offset: " + this.TimeZoneSelector.getUtcOffset() / 1000 / 60 / 60 + " Hours";
        //}

    }


    _onValueChangeTzSelector(): void {

        if (this.TimeZoneSelector.inputDate) {

            this.TimeZone_DateTimeInput.setValue(this.TimeZoneSelector.getSelectedLocaleDate_Date());


            //this.TimeZoneSelector_display.innerHTML =
            //    "UTC Time: " + this.TimeZoneSelector.getUtcDate() + "<br>" +
            //    "selectedLocalDate_Date: " + this.TimeZoneSelector.getSelectedLocaleDate_Date() + "<br>" +
            //    "UTC Offset: " + this.TimeZoneSelector.getUtcOffset() / 1000 / 60 /60 + " Hours";

        }

    }
    // Combined ------------------------------------------------------------

    _onValueChange_DateTimeTZoneSelector() {

    }

    _onClick_DateTZSelector_getValue(): void {
        console.log("this.DateTimeTZoneSelector.getValue()", this.DateTimeTZoneSelector.getValue())
    }

    _onClick_DateTZSelector_enable_disable(): void {
        let isEnabled = this.DateTimeTZoneSelector.get_is_TimeZoneSelector()
        if (isEnabled) {
            this.DateTimeTZoneSelector.disableTimeZoneSelector();
        } else {
            this.DateTimeTZoneSelector.enableTimeZoneSelector();
        }
    }

    // TIMETON SELECTOR ------------------------------------------------------END
    // Google reCaptcha -------------------------------------------------------START
    _onClick_greCaptcha_trigger(): void {
        console.log(window.grecaptcha)

        window.grecaptcha.render('recaptcha', {
            'sitekey': '6Ldh69IZAAAAAITw88jvQjttpl5tKLrAVppedUVh',
            'callback': window.reCaptcha_dataCallback
        });

        //window.grecaptcha.execute();
    }

    verifyCaptchaToken(respToken?: string): void {

        console.log("im the verification function!!!")

        let requestUrl = window.appRoot + "demodata/ValidateCapture"
        let requestParams = { "jsonData": JSON.stringify({ recapture_response: respToken }) };
        this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, "verifyCaptchaToken_completeHandler"),
            lang.hitch(this, "verifyCaptchaToken_errorHandler")
        );

    }

    verifyCaptchaToken_completeHandler(response: any): void {

        console.log("verifyCaptchaToken_completeHandler:: ", response);
        this.UiModder.domAttr.set(this.grecaptcha_display, "innerHTML", "RESPONSE Message: " + response["message"] + ". Sorry, you are not a robot.");


        if (response["message"] == "success") {
            // do something if success
            this.emit("reCaptcha_validationSuccess");
            window.grecaptcha.reset();
        }
    }

    verifyCaptchaToken_errorHandler(err: any): void {
        console.log("verifyCaptchaToken_errorHandler:: ", err);
    }
    // Google reCaptcha -------------------------------------------------------END

    // Boring static Table ----------------------------------------------------START

    Test_The_Table__TTT(): void {

        this.staticTable.setFormatter(function (cell: StaticTable.StaticTableCell<any>) {
            let header = cell.name;
            let node = cell.tableCellNode;
            let rowIndex = cell.tableRow.lineIndex;
            let entity = cell.entity;
            let value = cell.value;
            switch (header) {

                case "Button":
                    var btn = this.UiModder.domConstruct.create("BUTTON", {
                        "innerHTML": "Button label",
                        "value": rowIndex,
                        "onclick": function () {
                            window.dojo.publish("tableRowButton", { entity: entity, rowIndex: rowIndex });
                        }
                    }, node);
                    break;

                case "Input":
                    let input = new NumberInput();
                    this.addWidgetToRegistry(input, rowIndex, header);
                    input.placeAt(node);
                    break;

                case "Checkbox":
                    let checkbox = new CheckBox();
                    checkbox.setLabel("checkBox Lbl");
                    this.addWidgetToRegistry(checkbox, rowIndex, header);
                    checkbox.placeAt(node);
                    break;

                default:
                    node.innerHTML = value;

            }
            return true;
        });

        this.staticTable.setConditionalStyleClass("ref_occurrence_status.description", "open", "w3-red");
    }


    tableRowButton_click(rowData: object): void {

        let rowIndex = rowData["rowIndex"];

        //let rowWidgets = this.staticTable.getRowWidgets(rowIndex); // ????
        //let widetValues: Array<any> = [];

        //for (let i = 0; i < rowWidgets.length; i++) {
        //    widetValues.push(rowWidgets[i].getValue());
        //}

        //console.log("IMAGINARY_REQUEST: ", { entity: rowData["entity"], widgetValues: widetValues })

        // TODO: reparieren...
    }



    // Boring static Table ----------------------------------------------------END

    // Select Enitity Dialog --------------------------------------------------START
    //_onClick_selectEntityDialog_trigger() {

    //    //if (typeof (evt) != "undefined") {
    //    //    evt.stopPropagation();
    //    //}

    //    var entityDialog = new SelectEntityDialog();

    //    // Initialkonfig:

    //    entityDialog.init("Land wählen", "description_D", "", true); // init(dlgLabel, displayAttribute, initialValue?, bMultiSelect?)



    //    entityDialog.addTree("Africa", "Africa");
    //    entityDialog.addTree("America", "America");
    //    entityDialog.addTree("Asia", "Asia");
    //    entityDialog.addTree("Europa", "Europa");

    //    entityDialog.set("AllowEmptyValue", false);

    //    entityDialog.setFunction("Webtool_API_DemoData__GetCountriesByContinent"); // Der Name der API Funktion

    //    entityDialog.on("select", lang.hitch(this, "_onEntityDialog_select"));

    //    entityDialog.showSearchDialog();

    //    return entityDialog;
    //}

    _onEntityDialog_select(selection) {
        console.log("_onEntityDialog_select: ", selection);
    }


    // Select Enitity Dialog --------------------------------------------------END

    // Calendar --------------------------------------------------------------Start

    _onClick_calendar_setData(): void {

        this.Calendar.configureCalendar();
        this.Calendar.setData(this.CalendarDummyData);



    }

    _onClick_calendar_showEndTime(): void {
        this.Calendar.setShowEndtime(!this.Calendar.showEndtime);
    }

    _onClick_calendar_hideColHead(): void {
        this.Calendar.setHideColumnHead(!this.Calendar.hideColumnHead);
    }

    _onClick_calendar_setTextAttributes(): void {
        let columnHeadAttr: string = this.edit_demo_columnHeadText.value;
        let colBodyAttr: string = this.edit_demo_columnBodyText.value;
        this.Calendar.setColumnView_headText_attribute(columnHeadAttr);
        this.Calendar.setColumnView_bodyText_attribute(colBodyAttr);


    }

    _onClick_calendar_setAllDayMode(): void {
        this.Calendar.setAllDayMode(!this.Calendar.allDayMode);
    };


    // Calendar --------------------------------------------------------------END

    // searchSelect -------------------------------------------------------------START

    _onchange_SearchSelect(val: string): void {
        console.log("CHANGE SEARCHSELECT ", val);
        alert("Selected value: " + val);
    }

    // searchSelect -------------------------------------------------------------END

    // nestedTable -------------------------------------------------------------------------START

    // NST Props ---------------------------------

    // hier nehme ich die Daten/API vom ProjectFinder
    nestedTable_reqData: any = JSON.stringify({
        "sections": [
            {
                "_sectionName": "searchParameter",
                "startTime": "1782-01-01",
                "endTime": "1782-01-31"
            },
            {
                "_sectionName": "resultviewParameter",
                "view": "table",
                "displayDate": "2021-07-13"
            }
        ],
        "limit": 99,
        "currentStartIndex": 0
    });

    nestedTableConfig: NestedTableConfig;

    // widget-instanziierung in td ggf hier
    nestedTable_formatterFunction: Function = lang.hitch(this,
        function (cell: StaticTable.StaticTableCell<any>) {

            let node = cell.contentnode;
            let entity = cell.entity;
            let colName = cell.name;
            let value = cell.value;
            switch (colName) {
            case "Start":
                //2021-03-15T10:00:00 to human-readable
                var sYear: string = value.slice(0, 4);
                var sMonth: string = value.slice(5, 7);
                var sDay: string = value.slice(8, 10);
                var sHour: string = value.slice(11, 13);
                var sMinute: string = value.slice(14, 16);
                node.innerHTML = `${sDay}.${sMonth}.${sYear}, ${sHour}:${sMinute}`;
                break;
            case "Ende":
                //2021-03-15T10:00:00 to human-readable
                var sYear: string = value.slice(0, 4);
                var sMonth: string = value.slice(5, 7);
                var sDay: string = value.slice(8, 10);
                var sHour: string = value.slice(11, 13);
                var sMinute: string = value.slice(14, 16);
                node.innerHTML = `${sDay}.${sMonth}.${sYear}, ${sHour}:${sMinute}`;
                break;
            default:
                if (value == null || value == "" || typeof value == "undefined") value = "N.A.";
                node.innerHTML = value;
        }
    });

    // ----------------------NST get data

    _getNSTLayouts(): void {
        this.RequestManager.post(
            window.appRoot + "ProjectFinder/GetFilterpanelOptions",
            {
                jsonData: null
            },
            lang.hitch(this, this._onGetNSTLayoutsResponse),
            lang.hitch(this, this._onGetNSTLayoutsError),
            false // sync
        );
    }

    _getNSTData() {

        this.RequestManager.post(
            window.appRoot + "ProjectFinder/GetProjectList",
            {
                jsonData: this.nestedTable_reqData
            },
            lang.hitch(this, this._onGetNSTDataResponse),
            lang.hitch(this, this._onGetNSTDataError),
            false // sync
        );
    }

    _onGetNSTDataResponse(response): void {
        this.processFilterListResponse(response);
    }

    // Daten aufbereiten..  response:  {layoutname: bla, metadata:bla,  items: calenderItem[].Entity }
    processFilterListResponse(response) {

        let _completeList = [];

        for (let entity of response["items"]) {

            let tableEntity: object;


            tableEntity = this.PitHelper.getEntityAttributeValue(entity, "Entity", more.PitHelperStructureFormatType.json);
            if (!tableEntity) console.log("PitHelper could not get the entityAttributeValue for ", "Entity", " in ", entity)

            if (_completeList.length) {
                let index: number = -1;
                for (let i = 0; i < _completeList.length; i++) {
                    if (_completeList[i].ID == tableEntity["ID"] && _completeList[i].ID != null && tableEntity["ID"] != null) {
                        index = i;
                    }
                }
                if (index == -1) {
                    _completeList.push(tableEntity);
                } else {
                    _completeList[index] = tableEntity;
                }
            } else {
                _completeList.push(tableEntity);
            }
        }

        this._setNestedTable(_completeList);

    }
    _onGetNSTDataError(err): void {
        console.log("ERRR: ", err);
    }

    _onGetNSTLayoutsResponse(data): void {
        if (data && data.tableLayouts) {
            this.nestedTableConfig = data.tableLayouts;
            this._getNSTData();
        }
    }
    _onGetNSTLayoutsError(err): void {
        console.log(err);
    }

    // -----------------------------------NST set data

    _setNestedTable(data: Array<{}>): void {

        this.NestedTable.setFormatter(this.nestedTable_formatterFunction);

        this.NestedTable.setData(data);

        this.NestedTable.addLineConfig(<NestedTableConfig>this.nestedTableConfig);

    }



    // nestedTable -------------------------------------------------------------------------END


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///
        this.addSubscription("/grecaptcha/callback", lang.hitch(this, "verifyCaptchaToken"));
        this.addSubscription("tableRowButton", lang.hitch(this, "tableRowButton_click"));
        this.Test_The_Table__TTT();

        // programmatische instanziierung tests
        //this.Calendar.showCalendarButtons(true); gibs nicht mehr
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.edit_demo_node.on("valueChange", lang.hitch(this, "_onChange_Edit_DisplayValue"));

        this.fileUpload.showCustomSelectButton(true);
        this.fileUpload.setInputButtonLabel("I'M CUSTOM, PUSH ME");

        this.staticTable.setData(this.tableDummyData)

        this.MultiselectBox.loadListValues();

        this.SearchSelect.loadListValues(null, false);

        this.hintbox_Demo01.enablePlainTextValue = true;
        this.hintbox_Demo01.resetOnEdit = true;

        this._getNSTLayouts();
    }



    // TEST Node --------START




    // TEST Node --------END
    CalendarDummyData: any = {
        "mode": "week",
        "displayDate": "2021-03-10T22:30:00",
        "items": [
            {
                "id": "000000e9:001ed256",
                "Classname": "ev_booking",
                "barview_text": "The Music of HARRY POTTER ",
                "columnview_head_text": "The Music of HARRY POTTER ",
                "columnview_body_text": "",
                "groupValue": "GS",
                "bOverrideColoration": false,
                "coloration": [

                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T20:00:00",
                "endTime": "2021-03-10T22:30:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:001f60ba",
                "Classname": "ev_booking",
                "barview_text": "Heinz Erhardt Musical",
                "columnview_head_text": "Heinz Erhardt Musical",
                "columnview_body_text": "",
                "groupValue": "HF1",

                "bOverrideColoration": false,
                "coloration": [

                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T19:00:00",
                "endTime": "2021-03-09T20:00:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:002015ee",
                "Classname": "ev_booking",
                "barview_text": "Helge Schneider",
                "columnview_head_text": "Helge Schneider",
                "columnview_body_text": "",
                "groupValue": "GS",

                "bOverrideColoration": false,
                "coloration": [

                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-08T20:00:00",
                "endTime": "2021-03-08T22:30:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:0020ea4c",
                "Classname": "ev_booking",
                "barview_text": "Dienstberatung (IDB)",
                "columnview_head_text": "Dienstberatung (IDB)",
                "columnview_body_text": "",
                "groupValue": "BR",

                "bOverrideColoration": false,
                "coloration": [

                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T10:15:00",
                "endTime": "2021-03-09T12:30:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0020fb6a",
                "Classname": "ev_booking",
                "barview_text": "Kammermusik",
                "columnview_head_text": "Kammermusik",
                "columnview_body_text": "",
                "groupValue": "MSF",

                "bOverrideColoration": false,
                "coloration": [

                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-14T17:00:00",
                "endTime": "2021-03-14T18:00:00",
                "calendar": "MSF"
            },
            {
                "id": "000000e9:002147e1",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",

                "bOverrideColoration": false,
                "coloration": [

                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T08:30:00",
                "endTime": "2021-03-09T09:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:0021480f",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T10:30:00",
                "endTime": "2021-03-09T11:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:00214810",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T11:00:00",
                "endTime": "2021-03-09T12:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:00214863",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MSF",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T08:30:00",
                "endTime": "2021-03-10T09:00:00",
                "calendar": "MSF"
            },
            {
                "id": "000000e9:002159d3",
                "Classname": "ev_booking",
                "barview_text": "Chorkonzert",
                "columnview_head_text": "Chorkonzert",
                "columnview_body_text": "",
                "groupValue": "GS",
                "Default_BackColor": "80ff80",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "80ff80",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-13T10:00:00",
                "endTime": "2021-03-13T13:00:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:0021d142",
                "Classname": "ev_booking",
                "barview_text": "Vertriebsroutine",
                "columnview_head_text": "Vertriebsroutine",
                "columnview_body_text": "",
                "groupValue": "112",
                "Default_BackColor": "ffc1ff",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffc1ff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T09:00:00",
                "endTime": "2021-03-10T10:00:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:001ed255",
                "Classname": "ev_booking",
                "barview_text": "The Music Of Harry Potter",
                "columnview_head_text": "The Music Of Harry Potter",
                "columnview_body_text": "",
                "groupValue": "GS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T19:30:00",
                "endTime": "2021-03-10T20:00:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:001f60bb",
                "Classname": "ev_booking",
                "barview_text": "Heinz Erhardt Musical",
                "columnview_head_text": "Heinz Erhardt Musical",
                "columnview_body_text": "",
                "groupValue": "GS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T19:30:00",
                "endTime": "2021-03-09T20:00:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:001f7dee",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-11T09:00:00",
                "endTime": "2021-03-11T10:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:001f7e11",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MSF",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-11T10:00:00",
                "endTime": "2021-03-11T10:30:00",
                "calendar": "MSF"
            },
            {
                "id": "000000e9:002015ed",
                "Classname": "ev_booking",
                "barview_text": "Helge Schneider",
                "columnview_head_text": "Helge Schneider",
                "columnview_body_text": "",
                "groupValue": "GS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-08T19:30:00",
                "endTime": "2021-03-08T20:00:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:00202bbd",
                "Classname": "ev_booking",
                "barview_text": "Kammermusik",
                "columnview_head_text": "Kammermusik",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": true,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-13T00:00:00",
                "endTime": "2021-03-15T00:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:002147e2",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MSF",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T08:30:00",
                "endTime": "2021-03-09T09:00:00",
                "calendar": "MSF"
            },
            {
                "id": "000000e9:0021488d",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MSF",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T10:30:00",
                "endTime": "2021-03-10T11:00:00",
                "calendar": "MSF"
            },
            {
                "id": "000000e9:0021488e",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T10:30:00",
                "endTime": "2021-03-10T11:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:0021488f",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T11:00:00",
                "endTime": "2021-03-10T12:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:002159b5",
                "Classname": "ev_booking",
                "barview_text": "Chorkonzert",
                "columnview_head_text": "Chorkonzert",
                "columnview_body_text": "",
                "groupValue": "GS",
                "Default_BackColor": "80ff80",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "80ff80",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-12T12:00:00",
                "endTime": "2021-03-12T18:30:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:002159f1",
                "Classname": "ev_booking",
                "barview_text": "Chorkonzert",
                "columnview_head_text": "Chorkonzert",
                "columnview_body_text": "",
                "groupValue": "GS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-13T15:30:00",
                "endTime": "2021-03-13T16:00:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:0021bf14",
                "Classname": "ev_booking",
                "barview_text": "Musikwerkstatt \"Klangschmiede\" ",
                "columnview_head_text": "Musikwerkstatt \"Klangschmiede\" ",
                "columnview_body_text": "",
                "groupValue": "068",
                "Default_BackColor": "80ff80",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "80ff80",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T15:00:00",
                "endTime": "2021-03-09T18:00:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0021f54b",
                "Classname": "ev_booking",
                "barview_text": "Weiterbildungswoche",
                "columnview_head_text": "Weiterbildungswoche",
                "columnview_body_text": "",
                "groupValue": "HF1",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "0000ff"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-11T17:00:00",
                "endTime": "2021-03-11T17:30:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:001ed254",
                "Classname": "ev_booking",
                "barview_text": "The Music Of Harry Potter",
                "columnview_head_text": "The Music Of Harry Potter",
                "columnview_body_text": "",
                "groupValue": "HF1",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T19:00:00",
                "endTime": "2021-03-10T20:00:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:001f7dec",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-11T08:30:00",
                "endTime": "2021-03-11T09:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:001f7ded",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MSF",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-11T08:30:00",
                "endTime": "2021-03-11T09:00:00",
                "calendar": "MSF"
            },
            {
                "id": "000000e9:001febac",
                "Classname": "ev_booking",
                "barview_text": "Klavierabend",
                "columnview_head_text": "Klavierabend",
                "columnview_body_text": "",
                "groupValue": "MSF",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-13T18:30:00",
                "endTime": "2021-03-13T19:30:00",
                "calendar": "MSF"
            },
            {
                "id": "000000e9:00207c86",
                "Classname": "ev_booking",
                "barview_text": "Dispo",
                "columnview_head_text": "Dispo",
                "columnview_body_text": "",
                "groupValue": "CPS",
                "Default_BackColor": "ffc1ff",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffc1ff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T10:30:00",
                "endTime": "2021-03-10T12:30:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0021480e",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MSF",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T10:30:00",
                "endTime": "2021-03-09T11:00:00",
                "calendar": "MSF"
            },
            {
                "id": "000000e9:00214862",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T08:30:00",
                "endTime": "2021-03-10T09:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:00214864",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T09:00:00",
                "endTime": "2021-03-10T10:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:002159f0",
                "Classname": "ev_booking",
                "barview_text": "Chorkonzert",
                "columnview_head_text": "Chorkonzert",
                "columnview_body_text": "",
                "groupValue": "HF1",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-13T15:00:00",
                "endTime": "2021-03-13T16:00:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:00219259",
                "Classname": "ev_booking",
                "barview_text": "TRISTAN UND ISOLDE",
                "columnview_head_text": "TRISTAN UND ISOLDE",
                "columnview_body_text": "",
                "groupValue": "Oper",
                "Default_BackColor": "ffbe9f",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffbe9f",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-13T17:00:00",
                "endTime": "2021-03-13T21:45:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0021bf18",
                "Classname": "ev_booking",
                "barview_text": "Musikwerkstatt \"Klangwerkraum\" ",
                "columnview_head_text": "Musikwerkstatt \"Klangwerkraum\" ",
                "columnview_body_text": "",
                "groupValue": "068",
                "Default_BackColor": "80ff80",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "80ff80",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T18:00:00",
                "endTime": "2021-03-09T21:30:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0021ec42",
                "Classname": "ev_booking",
                "barview_text": "Routine Presse/Marketing",
                "columnview_head_text": "Routine Presse/Marketing",
                "columnview_body_text": "",
                "groupValue": "BR",
                "Default_BackColor": "ffc1ff",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffc1ff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-10T11:30:00",
                "endTime": "2021-03-10T12:30:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0021f54c",
                "Classname": "ev_booking",
                "barview_text": "Vortrag zum Gewandhaus",
                "columnview_head_text": "Vortrag zum Gewandhaus",
                "columnview_body_text": "",
                "groupValue": "HF2",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "0000ff",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "0000ff"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "0000ff"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-11T18:30:00",
                "endTime": "2021-03-11T19:00:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0021f55f",
                "Classname": "ev_booking",
                "barview_text": "Weiterbildungswoche",
                "columnview_head_text": "Weiterbildungswoche",
                "columnview_body_text": "",
                "groupValue": "HF2",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "0000ff",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "0000ff"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "0000ff"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-11T19:30:00",
                "endTime": "2021-03-11T22:00:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0021f576",
                "Classname": "ev_booking",
                "barview_text": "Führung",
                "columnview_head_text": "Führung",
                "columnview_body_text": "",
                "groupValue": "HF1",
                "Default_BackColor": "ffcccc",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffcccc",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "0000ff"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-11T17:30:00",
                "endTime": "2021-03-11T18:30:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:001f4d1d",
                "Classname": "ev_booking",
                "barview_text": "Elvis - Das Musical",
                "columnview_head_text": "Elvis - Das Musical",
                "columnview_body_text": "",
                "groupValue": "HF1",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-14T18:00:00",
                "endTime": "2021-03-14T19:00:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:001f4d1e",
                "Classname": "ev_booking",
                "barview_text": "Elvis - Das Musical",
                "columnview_head_text": "Elvis - Das Musical",
                "columnview_body_text": "",
                "groupValue": "GS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-14T18:30:00",
                "endTime": "2021-03-14T19:00:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:001f4d1f",
                "Classname": "ev_booking",
                "barview_text": "Elvis - Das Musical",
                "columnview_head_text": "Elvis - Das Musical",
                "columnview_body_text": "",
                "groupValue": "GS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-14T19:00:00",
                "endTime": "2021-03-14T21:30:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:001f60bc",
                "Classname": "ev_booking",
                "barview_text": "DAS HEINZ ERHARDT MUSICAL",
                "columnview_head_text": "DAS HEINZ ERHARDT MUSICAL",
                "columnview_body_text": "",
                "groupValue": "GS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T20:00:00",
                "endTime": "2021-03-09T22:30:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:001f7e10",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-11T10:00:00",
                "endTime": "2021-03-11T10:30:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:001f7e12",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-11T10:30:00",
                "endTime": "2021-03-11T11:30:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:001fe890",
                "Classname": "ev_booking",
                "barview_text": "Chor-Familienkonzert",
                "columnview_head_text": "Chor-Familienkonzert",
                "columnview_body_text": "",
                "groupValue": "GS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-13T16:00:00",
                "endTime": "2021-03-13T17:00:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:001febb3",
                "Classname": "ev_booking",
                "barview_text": "Klavierabend",
                "columnview_head_text": "Klavierabend",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-13T19:00:00",
                "endTime": "2021-03-13T19:30:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:001febb4",
                "Classname": "ev_booking",
                "barview_text": "Klavierabend mit Horacio Lavandera",
                "columnview_head_text": "Klavierabend mit Horacio Lavandera",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-13T19:30:00",
                "endTime": "2021-03-13T21:45:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:002015ec",
                "Classname": "ev_booking",
                "barview_text": "Helge Schneider",
                "columnview_head_text": "Helge Schneider",
                "columnview_body_text": "",
                "groupValue": "HF1",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-08T19:00:00",
                "endTime": "2021-03-08T20:00:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0020fb6b",
                "Classname": "ev_booking",
                "barview_text": "Kammermusik",
                "columnview_head_text": "Kammermusik",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ffa477",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffa477",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-14T17:30:00",
                "endTime": "2021-03-14T18:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:002147e3",
                "Classname": "ev_booking",
                "barview_text": "Schulkonzert",
                "columnview_head_text": "Schulkonzert",
                "columnview_body_text": "",
                "groupValue": "MS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "e7fee8",
                        "TextColor": "800040"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-09T09:00:00",
                "endTime": "2021-03-09T10:00:00",
                "calendar": "MS"
            },
            {
                "id": "000000e9:0021869b",
                "Classname": "ev_booking",
                "barview_text": "LOHENGRIN",
                "columnview_head_text": "LOHENGRIN",
                "columnview_body_text": "",
                "groupValue": "Oper",
                "Default_BackColor": "ffbe9f",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffbe9f",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-14T17:00:00",
                "endTime": "2021-03-14T17:00:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0021924a",
                "Classname": "ev_booking",
                "barview_text": "DER FLIEGENDE HOLLÄNDER",
                "columnview_head_text": "DER FLIEGENDE HOLLÄNDER",
                "columnview_body_text": "",
                "groupValue": "Oper",
                "Default_BackColor": "ffbe9f",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffbe9f",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-12T19:30:00",
                "endTime": "2021-03-12T22:15:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0021f579",
                "Classname": "ev_booking",
                "barview_text": "Orgelvorspiel",
                "columnview_head_text": "Orgelvorspiel",
                "columnview_body_text": "",
                "groupValue": "GS",
                "Default_BackColor": "ff7171",
                "Default_TextColor": "000000",
                "bOverrideColoration": false,
                "coloration": [
                    {
                        "ID": "00000233:00000001",
                        "ComplexAttributeName": "ref_ev_activity_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ff7171",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000002",
                        "ComplexAttributeName": "ref_ev_booking_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "d7ffe1",
                        "TextColor": "0000ff"
                    },
                    {
                        "ID": "00000233:00000003",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_status.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:00000004",
                        "ComplexAttributeName": "ref_ev_project.ref_ev_project_type_1.coloration",
                        "Classname": "ev_booking",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-11T19:00:00",
                "endTime": "2021-03-11T19:30:00",
                "calendar": "GS"
            },
            {
                "id": "000000e9:0022b756",
                "Classname": "appointment_comment",
                "barview_text": "Wieder Montag :(",
                "columnview_head_text": "Wieder Montag :(",
                "columnview_body_text": "",
                "Default_BackColor": "c1e0ff",
                "Default_TextColor": "000000",
                "bOverrideColoration": true,
                "coloration": [
                    {
                        "ID": "00000233:00000009",
                        "ComplexAttributeName": "is_finished",
                        "Classname": "appointment_comment",
                        "BackColor": "000000",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:0000000a",
                        "ComplexAttributeName": "holiday",
                        "Classname": "appointment_comment",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-08T13:30:00",
                "endTime": "2021-03-08T18:30:00",
                "calendar": "Sonst."
            },
            {
                "id": "000000e9:0022b757",
                "Classname": "appointment_comment",
                "barview_text": "Freitag Arbeit",
                "columnview_head_text": "Freitag Arbeit",
                "columnview_body_text": "",
                "Default_BackColor": "c1e0ff",
                "Default_TextColor": "000000",
                "bOverrideColoration": true,
                "coloration": [
                    {
                        "ID": "00000233:00000009",
                        "ComplexAttributeName": "is_finished",
                        "Classname": "appointment_comment",
                        "BackColor": "000000",
                        "TextColor": "000000"
                    },
                    {
                        "ID": "00000233:0000000a",
                        "ComplexAttributeName": "holiday",
                        "Classname": "appointment_comment",
                        "BackColor": "ffffff",
                        "TextColor": "000000"
                    }
                ],
                "allDay": false,
                "editable": true,
                "resizeEnabled": true,
                "moveEnabled": true,
                "startTime": "2021-03-12T08:00:00",
                "endTime": "2021-03-12T12:30:00",
                "calendar": "Sonst."
            }
        ]
    };

    tableDummyData: any = [{
        "ID": "00008100:00063da5",
        "Classname": "Occurrence",
        "Number": "E-005856",
        "Time": "2020-09-16T16:59:00",
        "ModificationDate": "2020-09-16T17:12:45",
        "ref_reporter": {
            "ID": "00008100:00045246",
            "Classname": "Employee",
            "DispName": "Weinberger, Ferdinand"
        },
        "ref_occurrence_type": {
            "ID": "000081a5:0000002a",
            "Classname": "Occurrence_type",
            "Name": "Request - Test for documentation"
        },
        "ref_cost_center2": {
            "ID": "00008100:000478fe",
            "Classname": "Cost_center",
            "Cost_center": "1002250"
        },
        "ref_occurrence_status": {
            "ID": "00008359:00000001",
            "Classname": "occurrence_status",
            "description": "open",
            "is_enable_rating": false,
            "sorting": 0,
            "is_edit_occurence_by_reporter": true,
            "Coloration": "ffffffff:bfbfff",
            "code": "o"
        },
        "evaluation_occurrence": 0,
        "note_evaluation": "",
        "To_complete_by": "2020-09-16T17:01:00",
        "is_complete_by_appointment": false,
        "tmp_ref_scheduled_task_executer": {
            "ID": "",
            "ref_employee": {
                "ID": "",
                "DispName": ""
            }
        },
        "ref_managed_object": {
            "ID": "00008100:0004dca7",
            "Classname": "Building",
            "tmp_label": "ABP Main Building"
        },
        "ref_building": {
            "ID": "00008100:0004dca7",
            "Classname": "Building",
            "tmp_label": "ABP Main Building"
        }
    }, {
        "ID": "00008100:0005c4b9",
        "Classname": "Occurrence",
        "Number": "E-005844",
        "Time": "2020-04-29T15:01:00",
        "ModificationDate": "2020-08-25T09:48:55",
        "ref_reporter": {
            "ID": "00008100:0004d84d",
            "Classname": "Employee",
            "DispName": "Fernandez Moreno, Pedro Luis"
        },
        "ref_occurrence_type": {
            "ID": "000081a5:0000002a",
            "Classname": "Occurrence_type",
            "Name": "Request - Test for documentation"
        },
        "ref_cost_center2": {
            "ID": "00008100:0004798f",
            "Classname": "Cost_center",
            "Cost_center": "1104340"
        },
        "ref_occurrence_status": {
            "ID": "00008359:00000008",
            "Classname": "occurrence_status",
            "description": "accepted",
            "is_enable_rating": false,
            "sorting": 12,
            "is_edit_occurence_by_reporter": true,
            "Coloration": "ffffffff:80ffff",
            "code": "a"
        },
        "evaluation_occurrence": 0,
        "note_evaluation": "",
        "To_complete_by": "2020-04-29T15:03:00",
        "is_complete_by_appointment": false,
        "tmp_ref_scheduled_task_executer": {
            "ID": "000082b2:00001f02",
            "Classname": "scheduled_task_executer",
            "ref_employee": {
                "ID": "00008100:00045246",
                "Classname": "Employee",
                "DispName": "Weinberger, Ferdinand"
            }
        },
        "ref_managed_object": {
            "ID": "00008100:00041fbb",
            "Classname": "Building",
            "tmp_label": "BHQ X - Building"
        },
        "ref_building": {
            "ID": "00008100:00041fbb",
            "Classname": "Building",
            "tmp_label": "BHQ X - Building"
        }
    }, {
        "ID": "00008100:00056955",
        "Classname": "Occurrence",
        "Number": "E-004674",
        "Time": "2020-03-05T12:38:00",
        "ModificationDate": "2020-04-11T16:41:56",
        "ref_reporter": {
            "ID": "00008100:0003fdcc",
            "Classname": "Employee",
            "DispName": "Misera, Steffen"
        },
        "ref_occurrence_type": {
            "ID": "000081a5:0000002a",
            "Classname": "Occurrence_type",
            "Name": "Request - Test for documentation"
        },
        "ref_cost_center2": {
            "ID": "00008100:000478fe",
            "Classname": "Cost_center",
            "Cost_center": "1002250"
        },
        "ref_occurrence_status": {
            "ID": "00008359:00000005",
            "Classname": "occurrence_status",
            "description": "settled",
            "is_enable_rating": true,
            "sorting": 30,
            "is_edit_occurence_by_reporter": false,
            "Coloration": "ffffffff:30d86f",
            "code": "erl"
        },
        "evaluation_occurrence": 0,
        "note_evaluation": "",
        "To_complete_by": "2020-03-05T12:40:00",
        "is_complete_by_appointment": false,
        "tmp_ref_scheduled_task_executer": {
            "ID": "",
            "ref_employee": {
                "ID": "",
                "DispName": ""
            }
        },
        "ref_managed_object": {
            "ID": "00008100:00041fbb",
            "Classname": "Building",
            "tmp_label": "BHQ X - Building"
        },
        "ref_building": {
            "ID": "00008100:00041fbb",
            "Classname": "Building",
            "tmp_label": "BHQ X - Building"
        }
    }, {
        "ID": "00008100:0005694b",
        "Classname": "Occurrence",
        "Number": "E-004670",
        "Time": "2020-03-05T12:20:00",
        "ModificationDate": "2020-03-05T12:33:27",
        "ref_reporter": {
            "ID": "00008100:0003fdcc",
            "Classname": "Employee",
            "DispName": "Misera, Steffen"
        },
        "ref_occurrence_type": {
            "ID": "000081a5:0000002a",
            "Classname": "Occurrence_type",
            "Name": "Request - Test for documentation"
        },
        "ref_cost_center2": {
            "ID": "00008100:000478fe",
            "Classname": "Cost_center",
            "Cost_center": "1002250"
        },
        "ref_occurrence_status": {
            "ID": "00008359:00000005",
            "Classname": "occurrence_status",
            "description": "settled",
            "is_enable_rating": true,
            "sorting": 30,
            "is_edit_occurence_by_reporter": false,
            "Coloration": "ffffffff:30d86f",
            "code": "erl"
        },
        "evaluation_occurrence": 0,
        "note_evaluation": "",
        "To_complete_by": "2020-03-05T12:22:00",
        "is_complete_by_appointment": false,
        "tmp_ref_scheduled_task_executer": {
            "ID": "000082b2:00001aba",
            "Classname": "scheduled_task_executer",
            "ref_employee": {
                "ID": "00008100:0003fdcc",
                "Classname": "Employee",
                "DispName": "Misera, Steffen"
            }
        },
        "ref_managed_object": {
            "ID": "00008100:00038e22",
            "Classname": "Building",
            "tmp_label": "BBR Showroom Brunnenstrasse"
        },
        "ref_building": {
            "ID": "00008100:00038e22",
            "Classname": "Building",
            "tmp_label": "BBR Showroom Brunnenstrasse"
        }
    }, {
        "ID": "00008100:0004ee8f",
        "Classname": "Occurrence",
        "Number": "E-000156",
        "Time": "2019-12-18T14:24:00",
        "ModificationDate": "2020-02-11T10:05:59",
        "ref_reporter": {
            "ID": "00008100:00044e51",
            "Classname": "Employee",
            "DispName": "Sammer, Armin"
        },
        "ref_occurrence_type": {
            "ID": "00008274:00000003",
            "Classname": "Occurrence_type",
            "Name": "Free text ticket"
        },
        "ref_cost_center2": {
            "ID": "00008100:000478fe",
            "Classname": "Cost_center",
            "Cost_center": "1002250"
        },
        "ref_occurrence_status": {
            "ID": "00008359:00000005",
            "Classname": "occurrence_status",
            "description": "settled",
            "is_enable_rating": true,
            "sorting": 30,
            "is_edit_occurence_by_reporter": false,
            "Coloration": "ffffffff:30d86f",
            "code": "erl"
        },
        "evaluation_occurrence": 0,
        "note_evaluation": "",
        "To_complete_by": "2019-12-18T14:44:00",
        "is_complete_by_appointment": false,
        "tmp_ref_scheduled_task_executer": {
            "ID": "000082b2:00000b37",
            "Classname": "scheduled_task_executer",
            "ref_employee": {
                "ID": "00008100:00045246",
                "Classname": "Employee",
                "DispName": "Weinberger, Ferdinand"
            }
        },
        "ref_managed_object": {
            "ID": "00008100:0004dcc7",
            "Classname": "Building",
            "tmp_label": "BGS Zapf Lager"
        },
        "ref_building": {
            "ID": "00008100:0004dcc7",
            "Classname": "Building",
            "tmp_label": "BGS Zapf Lager"
        }
    }, {
        "ID": "00008100:0004e1f2",
        "Classname": "Occurrence",
        "Number": "E-000086",
        "Time": "2019-11-11T15:13:00",
        "ModificationDate": "2020-03-05T09:38:42",
        "ref_reporter": {
            "ID": "00008100:00044e51",
            "Classname": "Employee",
            "DispName": "Sammer, Armin"
        },
        "ref_occurrence_type": {
            "ID": "000081a5:0000002a",
            "Classname": "Occurrence_type",
            "Name": "Request - Test for documentation"
        },
        "ref_cost_center2": {
            "ID": "00008100:000478fe",
            "Classname": "Cost_center",
            "Cost_center": "1002250"
        },
        "ref_occurrence_status": {
            "ID": "00008359:00000005",
            "Classname": "occurrence_status",
            "description": "settled",
            "is_enable_rating": true,
            "sorting": 30,
            "is_edit_occurence_by_reporter": false,
            "Coloration": "ffffffff:30d86f",
            "code": "erl"
        },
        "evaluation_occurrence": 2,
        "note_evaluation": "geht so",
        "To_complete_by": "2019-11-11T16:13:00",
        "is_complete_by_appointment": false,
        "tmp_ref_scheduled_task_executer": {
            "ID": "000082b2:00000b16",
            "Classname": "scheduled_task_executer",
            "ref_employee": {
                "ID": "00008100:00045246",
                "Classname": "Employee",
                "DispName": "Weinberger, Ferdinand"
            }
        },
        "ref_managed_object": {
            "ID": "00008100:00041fbb",
            "Classname": "Building",
            "tmp_label": "BHQ X - Building"
        },
        "ref_building": {
            "ID": "00008100:00041fbb",
            "Classname": "Building",
            "tmp_label": "BHQ X - Building"
        }
    }, {
        "ID": "00008100:0004e17b",
        "Classname": "Occurrence",
        "Number": "E-000068",
        "Time": "2019-11-04T10:39:00",
        "ModificationDate": "2020-01-28T12:25:11",
        "ref_reporter": {
            "ID": "00008100:00044e51",
            "Classname": "Employee",
            "DispName": "Sammer, Armin"
        },
        "ref_occurrence_type": {
            "ID": "000081a5:0000002a",
            "Classname": "Occurrence_type",
            "Name": "Request - Test for documentation"
        },
        "ref_cost_center2": {
            "ID": "00008100:000478fe",
            "Classname": "Cost_center",
            "Cost_center": "1002250"
        },
        "ref_occurrence_status": {
            "ID": "00008359:00000006",
            "Classname": "occurrence_status",
            "description": "wrong helpdesk",
            "is_enable_rating": true,
            "sorting": 99,
            "is_edit_occurence_by_reporter": false,
            "Coloration": "ffffffff:e8e8e8",
            "code": "fK"
        },
        "evaluation_occurrence": 0,
        "note_evaluation": "",
        "To_complete_by": "2019-11-04T11:39:00",
        "is_complete_by_appointment": false,
        "tmp_ref_scheduled_task_executer": {
            "ID": "000082b2:00000b10",
            "Classname": "scheduled_task_executer",
            "ref_employee": {
                "ID": "00008100:00045246",
                "Classname": "Employee",
                "DispName": "Weinberger, Ferdinand"
            }
        },
        "ref_managed_object": {
            "ID": "00008100:0004dca7",
            "Classname": "Building",
            "tmp_label": "ABP Main Building"
        },
        "ref_building": {
            "ID": "00008100:0004dca7",
            "Classname": "Building",
            "tmp_label": "ABP Main Building"
        }
    }, {
        "ID": "00008100:0004803f",
        "Classname": "Occurrence",
        "Number": "E-000011",
        "Time": "2019-06-27T15:57:00",
        "ModificationDate": "2020-01-28T12:28:02",
        "ref_reporter": {
            "ID": "00008100:00035a6a",
            "Classname": "Fachbereich",
            "DispName": "T|test"
        },
        "ref_occurrence_type": {
            "ID": "000081a5:00000015",
            "Classname": "Occurrence_type",
            "Name": "Emptying confidential waste bin"
        },
        "ref_cost_center2": {
            "ID": "",
            "Cost_center": ""
        },
        "ref_occurrence_status": {
            "ID": "00008359:00000005",
            "Classname": "occurrence_status",
            "description": "settled",
            "is_enable_rating": true,
            "sorting": 30,
            "is_edit_occurence_by_reporter": false,
            "Coloration": "ffffffff:30d86f",
            "code": "erl"
        },
        "evaluation_occurrence": 0,
        "note_evaluation": "",
        "To_complete_by": "2019-06-29T23:57:00",
        "is_complete_by_appointment": false,
        "tmp_ref_scheduled_task_executer": {
            "ID": "",
            "ref_employee": {
                "ID": "",
                "DispName": ""
            }
        },
        "ref_managed_object": {
            "ID": "00008100:00038e4a",
            "Classname": "Building",
            "tmp_label": "LWF Verwaltung"
        },
        "ref_building": {
            "ID": "00008100:00038e4a",
            "Classname": "Building",
            "tmp_label": "LWF Verwaltung"
        }
    }
    ];
}

export default mdsWidget(DemoApp);
